import React from 'react';
import { useRoutes } from 'react-router-dom';
import { NotFoundPage } from './guards';
import { adminRoutes } from './adminRoutes';
import { publicRoutes } from './publicRoutes';
import { workspaceRoutes } from './workspaceRoutes';
import { routePatterns } from './paths';

const routeObjects = [
  ...publicRoutes,
  ...workspaceRoutes,
  ...adminRoutes,
  { path: routePatterns.notFound, element: <NotFoundPage /> },
];

export function AppRoutes() {
  return useRoutes(routeObjects);
}
